import _ from "lodash";
import moment from "moment";
import "moment/locale/fr.js";
import { functionnal } from "vincent-utils";
import { checkers } from "vincent-utils";
import { formaters } from "vincent-utils";
class DdnObject {
    constructor(param) {
        if (_.isDate(param)) {
            this._ddnString = moment(param).format("DD/MM/YYYY");
            return;
        }
        else if (typeof param === "string") {
            if (checkers.isValidDdn(param)) {
                this._ddnString = param;
                return;
            }
        }
        throw new Error("invalid param in DdnObject constructor");
    }
    toString() {
        return this._ddnString;
    }
    getAgeObject() {
        return formaters.getAgeFromDDN(moment(this._ddnString, "DD/MM/YYYY").toDate());
    }
    getAge() {
        const ageObj = this.getAgeObject();
        if (ageObj &&
            functionnal.existy(ageObj.annees) &&
            functionnal.existy(ageObj.mois)) {
            return ageObj.mois / 12 + ageObj.annees;
        }
        throw new Error("getAge constraints not met in DdnObject class");
    }
    isEqual(ddn) {
        return ddn._ddnString === this._ddnString;
    }
}
export default DdnObject;
//# sourceMappingURL=ddnObject.js.map